module.exports = __webpack_public_path__ + "static/img/img4.e98f194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trade/img4.png
// module id = 67dZ
// module chunks = 1